<template>
  <Transition name="slide-left">
    <div v-if="isVisible" :class="transitionClass">
      <slot />
      <vs-bottom-sheet :is-visible="isBottomDrawerVisible">
        <slot name="bottom-drawer" />
      </vs-bottom-sheet>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import VsBottomSheet from '@/components/vision/VsBottomSheet.vue'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    isVisible: boolean
    isBottomDrawerVisible?: boolean
    fullWidth?: boolean
  }>(),
  {
    isBottomDrawerVisible: false,
    fullWidth: false,
  },
)

const transitionClass = computed(() => ({
  'side-drawer': true,
  'limit-max-width': !props.fullWidth,
}))
</script>

<style scoped>
.side-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  width: 100%;
  z-index: var(--elevation-sidesheet);
  background-color: #fff;
  box-shadow: var(--shadow-base);
}

.limit-max-width {
  max-width: 500px;
}
</style>
